export const confirmDeleteConstants = {
  MODAL_TITLE: 'Confirm Remove Invoice',
  MODAL_PARAGRAPH: 'Are you sure you want to remove the invoice{number}? This action cannot be undone.',
  CANCEL_BUTTON: 'Cancel',
  CONFIRM_BUTTON: 'Confirm',
}
export const editScheduleConstants = {
  NEW_INVOICES_BUTTON: 'New Invoice',
  UPLOAD_INVOICE_BUTTON: 'Upload Invoices',
}

export const scheduleTotalsConstants = {
  CLIENT_LABEL: 'Client',
  INVOICES_TOTAL_LABEL: 'Invoices Total',
  FUND_TOTAL_LABEL: 'Fund Invoice Total',
}
